import React from 'react';
import { CheckIcon, ShieldCheckIcon, CreditCardIcon, LockIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-5 sm:py-16 bg-[#0a1628] relative" data-id="element-162">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-163">
        <div className="text-center mb-4 sm:mb-8" data-id="element-164">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-165">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-166"></div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-5 sm:mb-12" data-id="element-167">
          <div className="bg-[#fbbf24] py-1.5 sm:py-3 text-center" data-id="element-168">
            <span className="text-[#0a1628] font-black text-xs sm:text-lg tracking-wider uppercase" data-id="element-169">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-3 sm:p-8 text-center" data-id="element-170">
            <h3 className="text-lg sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-171">
              Kit Completo Lengua y Literatura Lista
            </h3>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-5 mb-3 sm:mb-6 text-left max-w-sm mx-auto border border-gray-200" data-id="element-172">
              <p className="font-bold text-gray-700 mb-2 sm:mb-3 uppercase text-[10px] sm:text-xs tracking-wide text-center" data-id="element-173">
                Incluye todo esto:
              </p>
              <ul className="space-y-1.5 sm:space-y-2" data-id="element-174">
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-175">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-176" />
                  Kit completo de contenidos de 1° a 6° año
                </li>
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-177">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-178" />
                  BONUS: Guía docente de primeros auxilios
                </li>
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-179">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-180" />
                  BONUS: Guía maestra de planificación anual
                </li>
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-181">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-182" />
                  BONUS: Actividades para tus clases
                </li>
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-183">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-184" />
                  Entrega por Drive (PDF)
                </li>
                <li className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-185">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-186" />
                  Garantía de 7 días
                </li>
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-3 sm:mb-4" data-id="element-187">
              <span className="text-gray-400 text-sm sm:text-xl line-through font-medium mb-0" data-id="element-188">
                $39.990
              </span>
              <span className="text-[#16a34a] text-2xl sm:text-3xl md:text-4xl font-black tracking-tight" data-id="element-189">
                $19.990 ARS
              </span>
            </div>

            <a href="https://checkout.kitonline.shop/cart/47338873815278:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-2xl font-black py-3.5 sm:py-4 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2 sm:mb-3" data-id="element-190">
              COMPRAR AHORA →
            </a>

            <div className="mb-3 sm:mb-4" data-id="element-191">
              <p className="text-[10px] sm:text-xs text-gray-500 mb-1 font-medium" data-id="element-192">
                Medios de pago:
              </p>
              <div className="flex items-center justify-center gap-1 text-gray-700 font-medium bg-gray-100 py-1.5 px-3 rounded-full text-[10px] sm:text-xs inline-flex" data-id="element-193">
                <CreditCardIcon className="h-3 w-3 mr-1 flex-shrink-0" data-id="element-194" />
                <span data-id="element-195">Transferencia por WhatsApp · Mercado Pago · Tarjeta</span>
              </div>
            </div>

            <div className="flex items-center justify-center text-gray-500 text-[10px] sm:text-xs font-medium mb-2" data-id="element-196">
              <LockIcon className="h-3 w-3 mr-1" data-id="element-197" />
              PAGO SEGURO CON MERCADO PAGO
            </div>

            <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-198">
              Luego del pago, te enviamos el acceso por Drive automáticamente.
            </p>
          </div>
        </div>

        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border border-gray-700 relative" data-id="element-199">
          <div className="absolute top-0 right-0 bg-[#dc2626] text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 sm:py-1 rounded-bl-lg uppercase" data-id="element-200">
            Oferta Limitada
          </div>

          <div className="p-3 sm:p-6 md:p-8" data-id="element-201">
            <div className="text-center mb-3 sm:mb-5" data-id="element-202">
              <span className="inline-block bg-blue-600 text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 rounded-full mb-2 uppercase tracking-wide" data-id="element-203">
                Pack Profesional
              </span>
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-1" data-id="element-204">
                KIT COMPLETO LENGUA Y LITERATURA + MALETÍN DE ACTIVIDADES
              </h3>
              <p className="text-gray-400 text-xs sm:text-sm mb-3" data-id="element-205">
                LLEVÁ TUS CLASES AL SIGUIENTE NIVEL SIN PERDER TIEMPO ARMANDO
                ACTIVIDADES DESDE CERO.
              </p>

              <a href="https://checkout.kitonline.shop/cart/47547462222062:1" className="block hover:opacity-90 transition-opacity mb-3 sm:mb-4" data-id="element-206">
                <img src="https://cdn.magicpatterns.com/uploads/5f2cAUb5sasmuhrRGr9nY1/20260117_2306_ImageGeneration_simple_compose_01kf7dm0wae5n8a82e4rhskdqy_(1).png" alt="Kit Completo + Maletín de Actividades" className="w-full h-auto rounded-lg shadow-lg max-w-md mx-auto" data-id="element-207" />
              </a>
            </div>

            <div className="flex flex-col items-center justify-center mb-3 sm:mb-4" data-id="element-208">
              <span className="text-gray-500 text-sm sm:text-lg line-through font-medium" data-id="element-209">
                $49.990
              </span>
              <span className="text-[#fbbf24] text-2xl sm:text-3xl font-bold" data-id="element-210">
                $24.990
              </span>
            </div>

            <div className="flex flex-col md:flex-row gap-3 sm:gap-6 items-center" data-id="element-211">
              <div className="flex-1 text-center md:text-left w-full" data-id="element-212">
                <a href="https://checkout.kitonline.shop/cart/47547462222062:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-2.5 sm:py-3 px-4 rounded-lg shadow-lg transition-colors text-center mb-2" data-id="element-213">
                  SÍ, QUIERO LA OFERTA →
                </a>

                <div className="flex items-center justify-center md:justify-start text-gray-400 text-[9px] sm:text-xs font-medium mb-3" data-id="element-214">
                  <ShieldCheckIcon className="h-3 w-3 mr-1" data-id="element-215" />
                  Transferencia por WhatsApp · Mercado Pago · Tarjeta
                </div>
              </div>

              <div className="flex-1 w-full" data-id="element-216">
                <ul className="space-y-1 sm:space-y-1.5 text-[10px] sm:text-xs text-gray-300" data-id="element-217">
                  <li className="flex items-start" data-id="element-218">
                    <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-219"></div>
                    Actividades listas para trabajar en clase
                  </li>
                  <li className="flex items-start" data-id="element-220">
                    <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-221"></div>
                    Ideal para reforzar lectura, escritura y análisis
                  </li>
                  <li className="flex items-start" data-id="element-222">
                    <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-223"></div>
                    Más variedad de propuestas sin planificar de más
                  </li>
                  <li className="flex items-start" data-id="element-224">
                    <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-225"></div>
                    Ahorro de tiempo y mayor participación de los alumnos
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}